export type Status = "Active" | "Inactive";

export type GymContact = {
  name: string;
  phone: string;
  email: string;
};

export type GymScreens = {
  premium?: number;
  basic?: number;
};
export type GymRow = {
  id: string;
  gymName: string;
  organisation: any;
  premium: number;
  basic: number;
  location: string;
  contactName: string;
  contactNumber: string;
  allowGuestAccess: boolean;
};

export enum GymRepeatSchedulePeriodType {
  // Daily = "Daily",
  Weekly = "Weekly",
  // Monthly = "Monthly",
  // Yearly = "Yearly",
}

export type Gym = {
  _id: string;
  gymid: string;
  name: string;
  organisation: any;
  state?: string;
  city?: string;
  location?: string;
  contact?: GymContact;
  screens?: GymScreens;
  status?: Status;
  autoRepeatSchedule?: boolean;
  repeatPeriodType?: GymRepeatSchedulePeriodType | null;
  allowGuestAccess?: boolean;
  geoLocation?: {
    latitude?: number;
    longitude?: number;
  };
  locationAccess?: boolean;
  locationRangeInMeters?: number;

};

export type GymFormErrors = {
  name?: string;
  organisation?: any;
  state?: string;
  city?: string;
  location?: string;
  contact?: {
    name?: string;
    email?: string;
    phone?: string;
  };
  screens?: {
    premium?: number;
    normal?: number;
  };
  allowGuestAccess?: string;
  geoLocation?: {
    latitude?: string;
    longitude?: string;
  };
  locationRangeInMeters?: string;
  locationAccess?: string;
};